import { buildClassName, lookupPreset } from "./util";

// id: "b31ef926-86fb-4762-bd01-017d505dd5fb"
// title: "Title - Leveling"
// type: :text
// key: "title"
// parent_id: nil
export const TitleB31ef92686fb4762Bd01017d505dd5fb = "Leveling";

// id: "7b267b6c-e53d-41b6-8abc-d5338e53f58f"
// title: "Signup Pages"
// type: :reference
// key: "signup-pages"
// parent_id: nil
export function SignupPages7b267b6cE53d41b68abcD5338e53f58f(props: any) {
  return (
    <SecondaryPage5e00d16d1e464b4e99db0fc71584315b parentTag="SignupPages7b267b6cE53d41b68abcD5338e53f58f" header={<SecondaryMarketingHeader23dc1cb3Caa842ddA3f4113c773c503f parentTag="Header1f8874f4D59f4f68Ac457d1e02402830" title="Join Us" />} {...props} />
  );
}

// id: "3cd84038-0ff6-498c-ade2-8b401f02dd0a"
// title: ""
// type: :reference
// key: "header"
// parent_id: "8a8076c4-7a58-4e6e-83b2-7bb9726cda08"
export function Header3cd840380ff6498cAde28b401f02dd0a(props: any) {
  return (
    <MembersAreaHeaderA34abb73E68a42fdBfa0A95e8e70a41c parentTag="Header3cd840380ff6498cAde28b401f02dd0a" navMenuSlug="members-primary-nav" {...props} />
  );
}

// id: "c486c538-3b2c-42e9-8f65-65284fe94714"
// title: ""
// type: :reference
// key: "footer"
// parent_id: "b6e762fb-9ca8-496a-a09c-9e076575c19c"
export function FooterC486c5383b2c42e98f6565284fe94714(props: any) {
  return (
    <DefaultFooter5c45b14aC97f4b60Bc2d667d053cffd1 parentTag="FooterC486c5383b2c42e98f6565284fe94714" {...props} />
  );
}

// id: "f54e85d4-e5c3-4632-a185-ce4c2b0cc716"
// title: ""
// type: :html
// key: "title"
// parent_id: "dc681546-d42e-496a-a5fa-c04061177fef"
export function TitleF54e85d4E5c34632A185Ce4c2b0cc716(props: any) {
  const { parentTag, ...rest } = props;
  props = rest;
  return (
    <>

    </>
  );
}

// id: "71e1eac2-1081-40a6-ab7c-35703ea66141"
// title: ""
// type: :text
// key: "postSlug"
// parent_id: "0983ef89-6614-400b-bd1b-2b06eb06ffee"
export const PostSlug71e1eac2108140a6Ab7c35703ea66141 = "home-page-posts2";

// id: "e119feb9-1d1e-4529-a70f-f675a57b68ce"
// title: ""
// type: :text
// key: "class"
// parent_id: "0628a2c4-f93d-485f-b069-a10de15613f8"
export const ClassE119feb91d1e4529A70fF675a57b68ce = "navigation";

// id: "b87d80fa-6261-4847-9d51-523e572c0e2e"
// title: "Join Us Page"
// type: :html
// key: "join-us-page"
// parent_id: nil
export function JoinUsPageB87d80fa626148479d51523e572c0e2e(props: any) {
  const { parentTag, ...rest } = props;
  props = rest;
  return (
    <div className={`${parentTag || ""} JoinUsPageB87d80fa626148479d51523e572c0e2e gf-page-layout`} header={<SecondaryMarketingHeader23dc1cb3Caa842ddA3f4113c773c503f parentTag="HeaderE9268404396b48e68cc97312afe77d2a" title="Join Us" />}>
      {props["header"] || <SecondaryMarketingHeader23dc1cb3Caa842ddA3f4113c773c503f parentTag="Header2945ed59B43847eaA7adD8b3931bcbcc" {...props} />}
      {props.children}
      {props["footer"] || <DefaultFooter5c45b14aC97f4b60Bc2d667d053cffd1 parentTag="Footer3610d6566863450e8b63F38e276a30fe" {...props} />}
    </div>
  );
}

// id: "b3f31a5e-17c9-4398-bcfd-60fd5026509a"
// title: "Page Quote"
// type: :html
// key: "page-quote"
// parent_id: nil
export function PageQuoteB3f31a5e17c94398Bcfd60fd5026509a(props: any) {
  const { parentTag, ...rest } = props;
  props = rest;
  return (
    <div className={`${parentTag || ""} PageQuoteB3f31a5e17c94398Bcfd60fd5026509a`}>
      <div>
      </div>
      <div>
      </div>
    </div>
  );
}

// id: "0e616d64-36b9-4ac1-9946-05e9d0ea3ac1"
// title: ""
// type: :html
// key: "logo"
// parent_id: "5c45b14a-c97f-4b60-bc2d-667d053cffd1"
export function Logo0e616d6436b94ac1994605e9d0ea3ac1(props: any) {
  const { parentTag, ...rest } = props;
  props = rest;
  return (
    <img src="https://mp1md-pub.s3.amazonaws.com/orgs/demo-1/logo-wide-white-with-font.svg" alt="Demo 1 logo" className={`${parentTag || ""} Logo0e616d6436b94ac1994605e9d0ea3ac1 logo`} />
  );
}

// id: "a4d4251a-90c2-49eb-b935-22dea79dfe9a"
// title: ""
// type: :reference
// key: "header"
// parent_id: "a097cee0-8d8d-413a-a15c-0179f8e61c62"
export function HeaderA4d4251a90c249ebB93522dea79dfe9a(props: any) {
  return (
    <MembersAreaHeaderA34abb73E68a42fdBfa0A95e8e70a41c parentTag="HeaderA4d4251a90c249ebB93522dea79dfe9a" {...props} />
  );
}

// id: "af7731ab-a331-4831-9f47-3df83d1397ce"
// title: ""
// type: :text
// key: "href"
// parent_id: "50569397-5139-4ef7-950a-c48ecb0a6738"
export const HrefAf7731abA33148319f473df83d1397ce = "/join";

// id: "c0d712c6-fc87-4f2b-84a8-8447e4469d9c"
// title: ""
// type: :text
// key: "navMenuSlug"
// parent_id: "12586cb1-1b85-4103-b901-d614f9cb41af"
export const NavMenuSlugC0d712c6Fc874f2b84a88447e4469d9c = "footer-nav";

// id: "63b455f7-23cf-48b0-ad6a-8cdb168303c5"
// title: "HREF"
// type: :text
// key: "href"
// parent_id: nil
export const Href63b455f723cf48b0Ad6a8cdb168303c5 = "/";

// id: "2d5e8210-e9fe-45a4-8ba2-f8e0ba350b11"
// title: "Public Events Page"
// type: :html
// key: "public-events-page"
// parent_id: nil
export function PublicEventsPage2d5e8210E9fe45a48ba2F8e0ba350b11(props: any) {
  const { parentTag, ...rest } = props;
  props = rest;
  return (
    <div className={`${parentTag || ""} PublicEventsPage2d5e8210E9fe45a48ba2F8e0ba350b11 gf-page-layout`}>
      {props["header"] || <SecondaryMarketingHeader23dc1cb3Caa842ddA3f4113c773c503f parentTag="Header1e3589f21700440f8f7c7199bee3eb64" title="Public Events" {...props} />}
      <main>
        {props.children}
      </main>
      {props["footer"] || <DefaultFooter5c45b14aC97f4b60Bc2d667d053cffd1 parentTag="Footer5e93120c5cd141fe8e51D10c87513bbb" {...props} />}
    </div>
  );
}

// id: "265cc7aa-2a5e-4fd6-9aee-e012b321a044"
// title: ""
// type: :html
// key: "about-hero-1"
// parent_id: "1585a1ba-a6cf-4f2d-a82b-502e90616984"
export function AboutHero1265cc7aa2a5e4fd69aeeE012b321a044(props: any) {
  const ContentSnippet = lookupPreset("ContentSnippet");
  const { parentTag, ...rest } = props;
  props = rest;
  return (
    <div className={`${parentTag || ""} AboutHero1265cc7aa2a5e4fd69aeeE012b321a044`}>
      <h1>
        Our Story
      </h1>
      <div className="about-description">
        {props["about-description"] || <ContentSnippet className="AboutDescription19e7a28bF8314d7d80a8928799936f69" parentTag={buildClassName("AboutDescription19e7a28bF8314d7d80a8928799936f69", parentTag)} contentSlug="about-hero-heading" {...props} />}
      </div>
    </div>
  );
}

// id: "5e6df4f1-62c5-496c-aa57-ed54f7b97854"
// title: ""
// type: :reference
// key: "header"
// parent_id: "57bddf80-a95c-4b28-84a3-b6f767211b60"
export function Header5e6df4f162c5496cAa57Ed54f7b97854(props: any) {
  return (
    <MembersAreaHeaderA34abb73E68a42fdBfa0A95e8e70a41c parentTag="Header5e6df4f162c5496cAa57Ed54f7b97854" {...props} />
  );
}

// id: "1667e577-7931-4ccc-8df6-4cc16e673405"
// title: ""
// type: :gf_preset
// key: "linked-logo"
// parent_id: "a11b52de-6dd4-4236-9744-1ed26c1ff7dd"
export function LinkedLogo1667e57779314ccc8df64cc16e673405(props: any) {
  const Link = lookupPreset("Link");
  const { parentTag, ...rest } = props;
  props = rest;
  return (
    <Link className="LinkedLogo1667e57779314ccc8df64cc16e673405" parentTag={buildClassName("LinkedLogo1667e57779314ccc8df64cc16e673405", parentTag)} className="linked-logo" url="/" label={<Label784b94679ac34f8489290c966a94a99c />} {...props} />
  );
}

// id: "204e46fd-20ff-49a9-a311-59eda5464b96"
// title: ""
// type: :text
// key: "navMenuSlug"
// parent_id: "3cd84038-0ff6-498c-ade2-8b401f02dd0a"
export const NavMenuSlug204e46fd20ff49a9A31159eda5464b96 = "members-primary-nav";

// id: "81f448c9-96c5-4331-a16a-a239380681e1"
// title: "Short Header"
// type: :html
// key: "short-header"
// parent_id: nil
export function ShortHeader81f448c996c54331A16aA239380681e1(props: any) {
  const Link = lookupPreset("Link");
  const PrimaryNavigation = lookupPreset("PrimaryNavigation");
  const { parentTag, ...rest } = props;
  props = rest;
  return (
    <div className={`${parentTag || ""} ShortHeader81f448c996c54331A16aA239380681e1 header-top`}>
      {props["linked-logo"] || <Link className="LinkedLogo387f55e4F2444b869705B79fe7dc34b1" parentTag={buildClassName("LinkedLogo387f55e4F2444b869705B79fe7dc34b1", parentTag)} label={<DefaultLogo5cedacf3997d4ed99b9bC409eef78445 parentTag="LabelDd7991635abe4af8Aba2422400635259" alt="logo" />} {...props} />}
      {props["navigation"] || <PrimaryNavigation className="NavigationB5f9877e27b34a3aA9783afc43bf92b0" parentTag={buildClassName("NavigationB5f9877e27b34a3aA9783afc43bf92b0", parentTag)} navMenuSlug="members-primary-nav" {...props} />}
    </div>
  );
}

// id: "a34abb73-e68a-42fd-bfa0-a95e8e70a41c"
// title: "Members Area Header"
// type: :reference
// key: "members-area-header"
// parent_id: nil
export function MembersAreaHeaderA34abb73E68a42fdBfa0A95e8e70a41c(props: any) {
  return (
    <ShortHeader81f448c996c54331A16aA239380681e1 parentTag="MembersAreaHeaderA34abb73E68a42fdBfa0A95e8e70a41c" header-top={<DefaultHeaderTopA11b52de6dd4423697441ed26c1ff7dd parentTag="HeaderTop89ffa68596e647cd8c43B1e02ad02d9e" navMenuSlug="members-primary-nav" />} {...props} />
  );
}

// id: "3610d656-6863-450e-8b63-f38e276a30fe"
// title: ""
// type: :reference
// key: "footer"
// parent_id: "b87d80fa-6261-4847-9d51-523e572c0e2e"
export function Footer3610d6566863450e8b63F38e276a30fe(props: any) {
  return (
    <DefaultFooter5c45b14aC97f4b60Bc2d667d053cffd1 parentTag="Footer3610d6566863450e8b63F38e276a30fe" {...props} />
  );
}

// id: "1e3589f2-1700-440f-8f7c-7199bee3eb64"
// title: ""
// type: :reference
// key: "header"
// parent_id: "2d5e8210-e9fe-45a4-8ba2-f8e0ba350b11"
export function Header1e3589f21700440f8f7c7199bee3eb64(props: any) {
  return (
    <SecondaryMarketingHeader23dc1cb3Caa842ddA3f4113c773c503f parentTag="Header1e3589f21700440f8f7c7199bee3eb64" title="Public Events" {...props} />
  );
}

// id: "0a7f8aa2-9720-454f-ac05-222beb52786d"
// title: ""
// type: :text
// key: "title"
// parent_id: "e9268404-396b-48e6-8cc9-7312afe77d2a"
export const Title0a7f8aa29720454fAc05222beb52786d = "Join Us";

// id: "1bf9f241-9c1d-4e06-a1f4-3f84a24d0a4a"
// title: ""
// type: :html
// key: "hero"
// parent_id: "ef224d12-7ceb-4027-b55c-15c4d59c533c"
export function Hero1bf9f2419c1d4e06A1f43f84a24d0a4a(props: any) {
  const Hero = lookupPreset("Hero");
  const ContentSnippet = lookupPreset("ContentSnippet");
  const { parentTag, ...rest } = props;
  props = rest;
  return (
    <section className={`${parentTag || ""} Hero1bf9f2419c1d4e06A1f43f84a24d0a4a`}>
      {props["hero-content"] || <Hero className="HeroContent8c49e5575ac14b079fa9Dc89f842fa6e" parentTag={buildClassName("HeroContent8c49e5575ac14b079fa9Dc89f842fa6e", parentTag)} postSlug="home-hero" {...props} />}
      {props["description"] || <ContentSnippet className="Description6413289786bc43b6Ab78684f46f78249" parentTag={buildClassName("Description6413289786bc43b6Ab78684f46f78249", parentTag)} postSlug="home-hero-description" contentSlug="home-hero-description" className="home-hero-description" {...props} />}
    </section>
  );
}

// id: "a57b808d-01b5-4347-bb19-e00ef81335dd"
// title: "Marketing Cards Body"
// type: :html
// key: "marketing-body"
// parent_id: nil
export function MarketingBodyA57b808d01b54347Bb19E00ef81335dd(props: any) {
  const { parentTag, ...rest } = props;
  props = rest;
  return (
    <div className={`${parentTag || ""} MarketingBodyA57b808d01b54347Bb19E00ef81335dd page-body`}>
      {props["marketingCards"] || <MarketingCardsFa9263ffEda148e1Ae018f3b4d4e2fcd parentTag="MarketingCards0983ef896614400bBd1b2b06eb06ffee" postSlug="home-page-posts2" {...props} />}
    </div>
  );
}

// id: "dc681546-d42e-496a-a5fa-c04061177fef"
// title: "Secondary Marketing Hero"
// type: :html
// key: "secondary-marketing-hero"
// parent_id: nil
export function SecondaryMarketingHeroDc681546D42e496aA5faC04061177fef(props: any) {
  const ContentSnippet = lookupPreset("ContentSnippet");
  const { parentTag, ...rest } = props;
  props = rest;
  return (
    <div className={`${parentTag || ""} SecondaryMarketingHeroDc681546D42e496aA5faC04061177fef hero`}>
      <h1>
        Our Story
      </h1>
      {props["about-description"] || <AboutDescriptionAda69417E71f4fd58a57F6171c168f33 />}
    </div>
  );
}

// id: "e392db0a-62bc-4247-8f75-1344f1cddcd3"
// title: ""
// type: :text
// key: "imageUrl"
// parent_id: "5cedacf3-997d-4ed9-9b9b-c409eef78445"
export const ImageUrlE392db0a62bc42478f751344f1cddcd3 = "https://mp1md-pub.s3-us-west-2.amazonaws.com/content/omEtAozQA9rCypTr_file.svg";

// id: "34bba55f-70be-4a4b-9147-81316cb16ad9"
// title: ""
// type: :gf_preset
// key: "groupflow"
// parent_id: "5c45b14a-c97f-4b60-bc2d-667d053cffd1"
export function Groupflow34bba55f70be4a4b914781316cb16ad9(props: any) {
  const GroupFlowTag = lookupPreset("GroupFlowTag");
  const { parentTag, ...rest } = props;
  props = rest;
  return (
    <GroupFlowTag className="Groupflow34bba55f70be4a4b914781316cb16ad9" parentTag={buildClassName("Groupflow34bba55f70be4a4b914781316cb16ad9", parentTag)} {...props} />
  );
}

// id: "ada69417-e71f-4fd5-8a57-f6171c168f33"
// title: "about-description"
// type: :html
// key: "about-description"
// parent_id: "dc681546-d42e-496a-a5fa-c04061177fef"
export function AboutDescriptionAda69417E71f4fd58a57F6171c168f33(props: any) {
  const ContentSnippet = lookupPreset("ContentSnippet");
  const { parentTag, ...rest } = props;
  props = rest;
  return (
    <div className={`${parentTag || ""} AboutDescriptionAda69417E71f4fd58a57F6171c168f33`}>
      {props["about-hero-heading"] || <ContentSnippet className="AboutHeroHeading6e290ee9Db0c433b88db2213731a7c3e" parentTag={buildClassName("AboutHeroHeading6e290ee9Db0c433b88db2213731a7c3e", parentTag)} contentSlug="about-hero-heading" {...props} />}
    </div>
  );
}

// id: "64132897-86bc-43b6-ab78-684f46f78249"
// title: ""
// type: :gf_preset
// key: "description"
// parent_id: "1bf9f241-9c1d-4e06-a1f4-3f84a24d0a4a"
export function Description6413289786bc43b6Ab78684f46f78249(props: any) {
  const ContentSnippet = lookupPreset("ContentSnippet");
  const { parentTag, ...rest } = props;
  props = rest;
  return (
    <ContentSnippet className="Description6413289786bc43b6Ab78684f46f78249" parentTag={buildClassName("Description6413289786bc43b6Ab78684f46f78249", parentTag)} postSlug="home-hero-description" contentSlug="home-hero-description" className="home-hero-description" {...props} />
  );
}

// id: "09bc8405-e1ee-4e89-a9e2-52d06d270cf3"
// title: "Members Header"
// type: :reference
// key: "header"
// parent_id: nil
export function Header09bc8405E1ee4e89A9e252d06d270cf3(props: any) {
  return (
    <MembersAreaHeaderA34abb73E68a42fdBfa0A95e8e70a41c parentTag="Header09bc8405E1ee4e89A9e252d06d270cf3" {...props} />
  );
}

// id: "b6e762fb-9ca8-496a-a09c-9e076575c19c"
// title: "Levels 1-4 Explained"
// type: :html
// key: "about-leveling-page"
// parent_id: nil
export function AboutLevelingPageB6e762fb9ca8496aA09c9e076575c19c(props: any) {
  const { parentTag, ...rest } = props;
  props = rest;
  return (
    <div className={`${parentTag || ""} AboutLevelingPageB6e762fb9ca8496aA09c9e076575c19c gf-page-layout`}>
      {props["header"] || <SecondaryMarketingHeader23dc1cb3Caa842ddA3f4113c773c503f parentTag="Header700b99fa20d542229c304824a608b81a" title="Leveling" {...props} />}
      {props.children}
      {props["footer"] || <DefaultFooter5c45b14aC97f4b60Bc2d667d053cffd1 parentTag="FooterC486c5383b2c42e98f6565284fe94714" {...props} />}
    </div>
  );
}

// id: "0628a2c4-f93d-485f-b069-a10de15613f8"
// title: ""
// type: :gf_preset
// key: "navigation"
// parent_id: "a11b52de-6dd4-4236-9744-1ed26c1ff7dd"
export function Navigation0628a2c4F93d485fB069A10de15613f8(props: any) {
  const PrimaryNavigation = lookupPreset("PrimaryNavigation");
  const { parentTag, ...rest } = props;
  props = rest;
  return (
    <PrimaryNavigation className="Navigation0628a2c4F93d485fB069A10de15613f8" parentTag={buildClassName("Navigation0628a2c4F93d485fB069A10de15613f8", parentTag)} className="navigation" navMenuSlug="marketing-primary-nav" {...props} />
  );
}

// id: "ef224d12-7ceb-4027-b55c-15c4d59c533c"
// title: ""
// type: :html
// key: "header"
// parent_id: "6a5727f2-037d-4506-9d66-0cb7ee7e4d89"
export function HeaderEf224d127ceb4027B55c15c4d59c533c(props: any) {
  const ContentSnippet = lookupPreset("ContentSnippet");
  const Hero = lookupPreset("Hero");
  const { parentTag, ...rest } = props;
  props = rest;
  return (
    <div className={`${parentTag || ""} HeaderEf224d127ceb4027B55c15c4d59c533c site-header`}>
      <div className="header-top-wrapper">
        <div className="header-top-opacity">
        </div>
        {props["header-top"] || <DefaultHeaderTopA11b52de6dd4423697441ed26c1ff7dd parentTag="HeaderTop0fd3ec7925904205A29eF16d7bf3ae9c" {...props} />}
      </div>
      {props["hero"] || <Hero1bf9f2419c1d4e06A1f43f84a24d0a4a />}
    </div>
  );
}

// id: "64e72cdb-a88b-434e-88ef-349331431676"
// title: ""
// type: :reference
// key: "footer"
// parent_id: "5e00d16d-1e46-4b4e-99db-0fc71584315b"
export function Footer64e72cdbA88b434e88ef349331431676(props: any) {
  return (
    <DefaultFooter5c45b14aC97f4b60Bc2d667d053cffd1 parentTag="Footer64e72cdbA88b434e88ef349331431676" {...props} />
  );
}

// id: "22906bf3-7247-4592-a078-dbf8e23f433d"
// title: ""
// type: :text
// key: "title"
// parent_id: "acb554c8-9bc9-4fd3-853c-389450e0a4ab"
export const Title22906bf372474592A078Dbf8e23f433d = "Resources";

// id: "1585a1ba-a6cf-4f2d-a82b-502e90616984"
// title: "About Us"
// type: :html
// key: "about-us-page"
// parent_id: nil
export function AboutUsPage1585a1baA6cf4f2dA82b502e90616984(props: any) {
  const ContentSnippet = lookupPreset("ContentSnippet");
  const MarketingCards = lookupPreset("MarketingCards");
  const { parentTag, ...rest } = props;
  props = rest;
  return (
    <div className={`${parentTag || ""} AboutUsPage1585a1baA6cf4f2dA82b502e90616984 gf-page-layout`}>
      {props["header"] || <SecondaryMarketingHeader23dc1cb3Caa842ddA3f4113c773c503f parentTag="Header468892015f8d41cc8434F311d0961140" title="About Us" {...props} />}
      {props["about-hero-1"] || <AboutHero1265cc7aa2a5e4fd69aeeE012b321a044 />}
      {props["body"] || <BodyAde53228Def14c86947d85268fa1b1fa />}
      {props["footer"] || <DefaultFooter5c45b14aC97f4b60Bc2d667d053cffd1 parentTag="FooterA35e60aaC0ac4dba9c0599fcf9bdf738" {...props} />}
    </div>
  );
}

// id: "693fe5f4-2273-440f-9229-30aaebf2e859"
// title: ""
// type: :text
// key: "postSlug"
// parent_id: "fa9263ff-eda1-48e1-ae01-8f3b4d4e2fcd"
export const PostSlug693fe5f42273440f922930aaebf2e859 = "home-page-posts2";

// id: "927e9c74-2e19-4426-9bca-0611737e6a95"
// title: ""
// type: :reference
// key: "header"
// parent_id: "5e00d16d-1e46-4b4e-99db-0fc71584315b"
export function Header927e9c742e1944269bca0611737e6a95(props: any) {
  return (
    <DefaultHeaderTopA11b52de6dd4423697441ed26c1ff7dd parentTag="Header927e9c742e1944269bca0611737e6a95" title="Secondary Page" {...props} />
  );
}

// id: "12586cb1-1b85-4103-b901-d614f9cb41af"
// title: ""
// type: :gf_preset
// key: "links"
// parent_id: "5c45b14a-c97f-4b60-bc2d-667d053cffd1"
export function Links12586cb11b854103B901D614f9cb41af(props: any) {
  const Navigation = lookupPreset("Navigation");
  const { parentTag, ...rest } = props;
  props = rest;
  return (
    <Navigation className="Links12586cb11b854103B901D614f9cb41af" parentTag={buildClassName("Links12586cb11b854103B901D614f9cb41af", parentTag)} navMenuSlug="footer-nav" {...props} />
  );
}

// id: "8c49e557-5ac1-4b07-9fa9-dc89f842fa6e"
// title: ""
// type: :gf_preset
// key: "hero-content"
// parent_id: "1bf9f241-9c1d-4e06-a1f4-3f84a24d0a4a"
export function HeroContent8c49e5575ac14b079fa9Dc89f842fa6e(props: any) {
  const Hero = lookupPreset("Hero");
  const { parentTag, ...rest } = props;
  props = rest;
  return (
    <Hero className="HeroContent8c49e5575ac14b079fa9Dc89f842fa6e" parentTag={buildClassName("HeroContent8c49e5575ac14b079fa9Dc89f842fa6e", parentTag)} postSlug="home-hero" {...props} />
  );
}

// id: "5cedacf3-997d-4ed9-9b9b-c409eef78445"
// title: "Logo"
// type: :html
// key: "default-logo"
// parent_id: nil
export function DefaultLogo5cedacf3997d4ed99b9bC409eef78445(props: any) {
  const { parentTag, ...rest } = props;
  props = rest;
  return (
    <img src="https://mp1md-pub.s3-us-west-2.amazonaws.com/content/omEtAozQA9rCypTr_file.svg" className={`${parentTag || ""} DefaultLogo5cedacf3997d4ed99b9bC409eef78445 logo`} alt="logo" />
  );
}

// id: "e0869089-28f4-4f64-b1d2-cb30d11836b4"
// title: "Resources Page"
// type: :reference
// key: "resources-page"
// parent_id: nil
export function ResourcesPageE086908928f44f64B1d2Cb30d11836b4(props: any) {
  return (
    <SecondaryPage5e00d16d1e464b4e99db0fc71584315b parentTag="ResourcesPageE086908928f44f64B1d2Cb30d11836b4" header={<SecondaryMarketingHeader23dc1cb3Caa842ddA3f4113c773c503f parentTag="HeaderAcb554c89bc94fd3853c389450e0a4ab" title="Resources" />} {...props} />
  );
}

// id: "7bad446b-ea50-4372-843b-b3f1190b2dfa"
// title: ""
// type: :text
// key: "alt"
// parent_id: "5cedacf3-997d-4ed9-9b9b-c409eef78445"
export const Alt7bad446bEa504372843bB3f1190b2dfa = "logo";

// id: "eb0b0733-712e-4fe6-af0c-78eee50ddb72"
// title: "Contact"
// type: :html
// key: "contact"
// parent_id: "5c45b14a-c97f-4b60-bc2d-667d053cffd1"
export function ContactEb0b0733712e4fe6Af0c78eee50ddb72(props: any) {
  const { parentTag, ...rest } = props;
  props = rest;
  return (
    <div className={`${parentTag || ""} ContactEb0b0733712e4fe6Af0c78eee50ddb72`}>
      <a className="info-item" href="https://www.google.com/maps/place/Buckley,+WA/@47.1624222,-122.0468909,14z/data=!3m1!4b1!4m6!3m5!1s0x5490e56a3ca1a827:0x1b3782310c07e03d!8m2!3d47.1631573!4d-122.0267787!16zL20vMDEwc3Yy?entry=ttu" noreferrer="" noopener="" target="_blank">
        <svg preserveAspectRatio="xMidYMid meet" data-bbox="53.5 36.5 93 127" viewBox="53.5 36.5 93 127" height="200" width="200" xmlns="http://www.w3.org/2000/svg" data-type="color" role="presentation" aria-hidden="true" aria-label="">
          <defs>
          </defs>
          <g>
            <path d="M99.999 163.5l-3.25-3.895C94.986 157.487 53.5 107.468 53.5 82.916 53.5 57.323 74.359 36.5 99.999 36.5c25.644 0 46.501 20.823 46.501 46.416 0 24.551-41.483 74.571-43.252 76.688l-3.249 3.896zm0-118.56c-20.978 0-38.046 17.036-38.046 37.977 0 16.359 25.019 51.015 38.046 67.305 13.029-16.29 38.048-50.946 38.048-67.305 0-20.942-17.068-37.977-38.048-37.977z" fill="currentColor" data-color="1" />
            <path d="M99.999 101.658c-10.351 0-18.775-8.407-18.775-18.741 0-10.335 8.424-18.743 18.775-18.743 10.353 0 18.777 8.408 18.777 18.743 0 10.333-8.424 18.741-18.777 18.741zm0-29.046c-5.69 0-10.32 4.621-10.32 10.304 0 5.68 4.63 10.303 10.32 10.303 5.692 0 10.324-4.622 10.324-10.303 0-5.682-4.632-10.304-10.324-10.304z" fill="currentColor" data-color="1" />
          </g>
        </svg>
        <span>
          Buckley, Washington
        </span>
      </a>
      <a className="info-item" href="mailto:wildferngrove@gmail.com" noreferrer="" noopener="" target="_blank">
        <svg preserveAspectRatio="xMidYMid meet" data-bbox="35 56 130 88" viewBox="35 56 130 88" height="200" width="200" xmlns="http://www.w3.org/2000/svg" data-type="color" role="presentation" aria-hidden="true" aria-label="">
          <g>
            <path d="M35 56v88h130V56H35zm64.879 58.87L49.15 64.499h101.455L99.879 114.87zM72.191 99.311l-28.755 30.025V70.757l28.755 28.554zm6.009 5.967l21.679 21.525 21.677-21.525 28.93 30.224H49.254L78.2 105.278zm49.364-5.967l29-28.796v59.092l-29-30.296z" fill="currentColor" data-color="1" />
          </g>
        </svg>
        <span>
          wildferngrove@gmail.com
        </span>
      </a>
    </div>
  );
}

// id: "32428d79-f980-40db-9879-1d1bacbbe1d0"
// title: ""
// type: :gf_preset
// key: "copyright"
// parent_id: "5c45b14a-c97f-4b60-bc2d-667d053cffd1"
export function Copyright32428d79F98040db98791d1bacbbe1d0(props: any) {
  const GroupCopyright = lookupPreset("GroupCopyright");
  const { parentTag, ...rest } = props;
  props = rest;
  return (
    <GroupCopyright className="Copyright32428d79F98040db98791d1bacbbe1d0" parentTag={buildClassName("Copyright32428d79F98040db98791d1bacbbe1d0", parentTag)} {...props} />
  );
}

// id: "e08a1793-4928-4e05-b3fe-075abca1f20a"
// title: ""
// type: :text
// key: "title"
// parent_id: "1f8874f4-d59f-4f68-ac45-7d1e02402830"
export const TitleE08a179349284e05B3fe075abca1f20a = "Join Us";

// id: "e6cf557a-5043-4948-b518-88cdb95eb3d1"
// title: ""
// type: :text
// key: "postSlug"
// parent_id: "a463275c-95cf-4139-9843-f2b6313bfe92"
export const PostSlugE6cf557a50434948B51888cdb95eb3d1 = "about-us-posts";

// id: "ea5f8825-2922-4a52-90ea-04d1d2976c00"
// title: "Admin Pages"
// type: :html
// key: "admin-pages"
// parent_id: nil
export function AdminPagesEa5f882529224a5290ea04d1d2976c00(props: any) {
  const { parentTag, ...rest } = props;
  props = rest;
  return (
    <div className={`${parentTag || ""} AdminPagesEa5f882529224a5290ea04d1d2976c00`}>
      {props.children}
    </div>
  );
}

// id: "5c45b14a-c97f-4b60-bc2d-667d053cffd1"
// title: "Footer"
// type: :html
// key: "default-footer"
// parent_id: nil
export function DefaultFooter5c45b14aC97f4b60Bc2d667d053cffd1(props: any) {
  const Navigation = lookupPreset("Navigation");
  const GroupCopyright = lookupPreset("GroupCopyright");
  const GroupFlowTag = lookupPreset("GroupFlowTag");
  const { parentTag, ...rest } = props;
  props = rest;
  return (
    <footer className={`${parentTag || ""} DefaultFooter5c45b14aC97f4b60Bc2d667d053cffd1 footer`}>
      {props["social"] || <SocialBa322a750852466299123c745556a2e7 />}
      {props["links"] || <Navigation className="Links12586cb11b854103B901D614f9cb41af" parentTag={buildClassName("Links12586cb11b854103B901D614f9cb41af", parentTag)} navMenuSlug="footer-nav" {...props} />}
      {props["contact"] || <ContactEb0b0733712e4fe6Af0c78eee50ddb72 />}
      <div className="spacing">
      </div>
      {props["site-logo-name"] || <SiteLogoName81d14398652d43408ee95ce4a8176229 />}
      {props["copyright"] || <GroupCopyright className="Copyright32428d79F98040db98791d1bacbbe1d0" parentTag={buildClassName("Copyright32428d79F98040db98791d1bacbbe1d0", parentTag)} {...props} />}
      {props["groupflow"] || <GroupFlowTag className="Groupflow34bba55f70be4a4b914781316cb16ad9" parentTag={buildClassName("Groupflow34bba55f70be4a4b914781316cb16ad9", parentTag)} {...props} />}
    </footer>
  );
}

// id: "c47a5a03-e5e9-474e-b21d-4720ecdc3880"
// title: "Services Clone ebTvTvYIRBhR5Aa"
// type: :gf_preset
// key: "services-posts"
// parent_id: "6a5727f2-037d-4506-9d66-0cb7ee7e4d89"
export function ServicesPostsC47a5a03E5e9474eB21d4720ecdc3880(props: any) {
  const MarketingCards = lookupPreset("MarketingCards");
  const { parentTag, ...rest } = props;
  props = rest;
  return (
    <MarketingCards className="ServicesPostsC47a5a03E5e9474eB21d4720ecdc3880" parentTag={buildClassName("ServicesPostsC47a5a03E5e9474eB21d4720ecdc3880", parentTag)} postSlug="home-page-offerings" {...props} />
  );
}

// id: "5d8a2f7f-269c-4532-8503-caba777bdfa1"
// title: ""
// type: :text
// key: "title"
// parent_id: "23dc1cb3-caa8-42dd-a3f4-113c773c503f"
export const Title5d8a2f7f269c45328503Caba777bdfa1 = "Secondary Marketing Title 1";

// id: "5dfd6dcc-1ff5-4dae-9e3e-810abea3ff7f"
// title: ""
// type: :text
// key: "postSlug"
// parent_id: "c47a5a03-e5e9-474e-b21d-4720ecdc3880"
export const PostSlug5dfd6dcc1ff54dae9e3e810abea3ff7f = "home-page-offerings";

// id: "1606a2e1-b61e-4b5b-9fa8-601f1fa71383"
// title: "Label"
// type: :reference
// key: "label"
// parent_id: nil
export function Label1606a2e1B61e4b5b9fa8601f1fa71383(props: any) {
  return (
    <DefaultLogo5cedacf3997d4ed99b9bC409eef78445 parentTag="Label1606a2e1B61e4b5b9fa8601f1fa71383" {...props} />
  );
}

// id: "697a975f-028b-4f17-8d43-6e00809c698c"
// title: "about-hero-heading"
// type: :text
// key: "contentSlug"
// parent_id: nil
export const ContentSlug697a975f028b4f178d436e00809c698c = "about-hero-heading";

// id: "700b99fa-20d5-4222-9c30-4824a608b81a"
// title: ""
// type: :reference
// key: "header"
// parent_id: "b6e762fb-9ca8-496a-a09c-9e076575c19c"
export function Header700b99fa20d542229c304824a608b81a(props: any) {
  return (
    <SecondaryMarketingHeader23dc1cb3Caa842ddA3f4113c773c503f parentTag="Header700b99fa20d542229c304824a608b81a" title="Leveling" {...props} />
  );
}

// id: "8e9f964b-0f89-4bc2-b756-788cb9660a44"
// title: ""
// type: :reference
// key: "footer"
// parent_id: "6a5727f2-037d-4506-9d66-0cb7ee7e4d89"
export function Footer8e9f964b0f894bc2B756788cb9660a44(props: any) {
  return (
    <DefaultFooter5c45b14aC97f4b60Bc2d667d053cffd1 parentTag="Footer8e9f964b0f894bc2B756788cb9660a44" {...props} />
  );
}

// id: "2151a24d-eefd-489c-bece-0d7a48801652"
// title: ""
// type: :reference
// key: "hero"
// parent_id: "23dc1cb3-caa8-42dd-a3f4-113c773c503f"
export function Hero2151a24dEefd489cBece0d7a48801652(props: any) {
  return (
    <SecondaryMarketingHeroDc681546D42e496aA5faC04061177fef parentTag="Hero2151a24dEefd489cBece0d7a48801652" title="Secondary Marketing Title 2" {...props} />
  );
}

// id: "0fd3ec79-2590-4205-a29e-f16d7bf3ae9c"
// title: ""
// type: :reference
// key: "header-top"
// parent_id: "ef224d12-7ceb-4027-b55c-15c4d59c533c"
export function HeaderTop0fd3ec7925904205A29eF16d7bf3ae9c(props: any) {
  return (
    <DefaultHeaderTopA11b52de6dd4423697441ed26c1ff7dd parentTag="HeaderTop0fd3ec7925904205A29eF16d7bf3ae9c" {...props} />
  );
}

// id: "23dc1cb3-caa8-42dd-a3f4-113c773c503f"
// title: "Secondary Marketing Header"
// type: :html
// key: "secondary-marketing-header"
// parent_id: nil
export function SecondaryMarketingHeader23dc1cb3Caa842ddA3f4113c773c503f(props: any) {
  const { parentTag, ...rest } = props;
  props = { title: "Secondary Marketing Title 1", ...rest };
  return (
    <div className={`${parentTag || ""} SecondaryMarketingHeader23dc1cb3Caa842ddA3f4113c773c503f site-header`}>
      <div className="header-top-wrapper">
        <div className="header-top-opacity">
        </div>
        {props["header-top"] || <DefaultHeaderTopA11b52de6dd4423697441ed26c1ff7dd parentTag="HeaderTop60f362681c744f0586853ec654761c5c" {...props} />}
      </div>
    </div>
  );
}

// id: "4b20c25c-aabd-4789-93cc-53e81a401f4f"
// title: "Default Header Reference"
// type: :reference
// key: "default-header"
// parent_id: nil
export function DefaultHeader4b20c25cAabd478993cc53e81a401f4f(props: any) {
  return (
    <ShortHeader81f448c996c54331A16aA239380681e1 parentTag="DefaultHeader4b20c25cAabd478993cc53e81a401f4f" navMenuSlug="marketing-primary-nav" title {...props} />
  );
}

// id: "0983ef89-6614-400b-bd1b-2b06eb06ffee"
// title: ""
// type: :reference
// key: "marketingCards"
// parent_id: "a57b808d-01b5-4347-bb19-e00ef81335dd"
export function MarketingCards0983ef896614400bBd1b2b06eb06ffee(props: any) {
  return (
    <MarketingCardsFa9263ffEda148e1Ae018f3b4d4e2fcd parentTag="MarketingCards0983ef896614400bBd1b2b06eb06ffee" postSlug="home-page-posts2" {...props} />
  );
}

// id: "a35e60aa-c0ac-4dba-9c05-99fcf9bdf738"
// title: ""
// type: :reference
// key: "footer"
// parent_id: "1585a1ba-a6cf-4f2d-a82b-502e90616984"
export function FooterA35e60aaC0ac4dba9c0599fcf9bdf738(props: any) {
  return (
    <DefaultFooter5c45b14aC97f4b60Bc2d667d053cffd1 parentTag="FooterA35e60aaC0ac4dba9c0599fcf9bdf738" {...props} />
  );
}

// id: "4e796079-9cb0-460b-b1b5-56e1b68c650c"
// title: "Common Footer"
// type: :reference
// key: "footer"
// parent_id: nil
export function Footer4e7960799cb0460bB1b556e1b68c650c(props: any) {
  return (
    <DefaultFooter5c45b14aC97f4b60Bc2d667d053cffd1 parentTag="Footer4e7960799cb0460bB1b556e1b68c650c" {...props} />
  );
}

// id: "6a5727f2-037d-4506-9d66-0cb7ee7e4d89"
// title: "Home Page"
// type: :html
// key: "home-page"
// parent_id: nil
export function HomePage6a5727f2037d45069d660cb7ee7e4d89(props: any) {
  const WelcomeBackPopUp = lookupPreset("WelcomeBackPopUp");
  const MarketingCards = lookupPreset("MarketingCards");
  const { parentTag, ...rest } = props;
  props = rest;
  return (
    <div className={`${parentTag || ""} HomePage6a5727f2037d45069d660cb7ee7e4d89 gf-page-layout`}>
      {props["header"] || <HeaderEf224d127ceb4027B55c15c4d59c533c />}
      <main>
        {props["welcome-back"] || <WelcomeBackPopUp className="WelcomeBack556a7f7a72314b7dBda685fc9337f952" parentTag={buildClassName("WelcomeBack556a7f7a72314b7dBda685fc9337f952", parentTag)} {...props} />}
        <div className="services-title" id="choose-your-own-adventure">
          <h2>
            Choose your own adventure at Wildfern Grove
          </h2>
        </div>
        <div>
          {props["services-posts"] || <MarketingCards className="ServicesPostsC47a5a03E5e9474eB21d4720ecdc3880" parentTag={buildClassName("ServicesPostsC47a5a03E5e9474eB21d4720ecdc3880", parentTag)} postSlug="home-page-offerings" {...props} />}
        </div>
      </main>
      {props["footer"] || <DefaultFooter5c45b14aC97f4b60Bc2d667d053cffd1 parentTag="Footer8e9f964b0f894bc2B756788cb9660a44" {...props} />}
    </div>
  );
}

// id: "1525c7c1-e826-448c-8d60-f15200a9ba2e"
// title: ""
// type: :reference
// key: "body"
// parent_id: "6a5727f2-037d-4506-9d66-0cb7ee7e4d89"
export function Body1525c7c1E826448c8d60F15200a9ba2e(props: any) {
  return (
    <MarketingBodyA57b808d01b54347Bb19E00ef81335dd parentTag="Body1525c7c1E826448c8d60F15200a9ba2e" {...props} />
  );
}

// id: "5e00d16d-1e46-4b4e-99db-0fc71584315b"
// title: "Secondary Page"
// type: :html
// key: "secondary-page"
// parent_id: nil
export function SecondaryPage5e00d16d1e464b4e99db0fc71584315b(props: any) {
  const { parentTag, ...rest } = props;
  props = rest;
  return (
    <div className={`${parentTag || ""} SecondaryPage5e00d16d1e464b4e99db0fc71584315b gf-page-layout`}>
      {props["header"] || <DefaultHeaderTopA11b52de6dd4423697441ed26c1ff7dd parentTag="Header927e9c742e1944269bca0611737e6a95" title="Secondary Page" {...props} />}
      {props.children}
      {props["footer"] || <DefaultFooter5c45b14aC97f4b60Bc2d667d053cffd1 parentTag="Footer64e72cdbA88b434e88ef349331431676" {...props} />}
    </div>
  );
}

// id: "2858f0fa-b0db-4a27-811a-950b42fac49b"
// title: "Marketing Primary Navigation"
// type: :text
// key: "navMenuSlug"
// parent_id: "4b20c25c-aabd-4789-93cc-53e81a401f4f"
export const NavMenuSlug2858f0faB0db4a27811a950b42fac49b = "marketing-primary-nav";

// id: "ba322a75-0852-4662-9912-3c745556a2e7"
// title: "Social Links"
// type: :html
// key: "social"
// parent_id: "5c45b14a-c97f-4b60-bc2d-667d053cffd1"
export function SocialBa322a750852466299123c745556a2e7(props: any) {
  const { parentTag, ...rest } = props;
  props = rest;
  return (
    <div className={`${parentTag || ""} SocialBa322a750852466299123c745556a2e7 flex flex-row justify-center gap-6 flex flex-row justify-center gap-6`}>
      <a className="hover:brightness-110" href="https://www.facebook.com/profile.php?id=61555136205304">
        <svg width="64" height="64" viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg" title="Facebook icon" className="fill-current" style={{width: "30px", height: "30px"}}>
          <path d="M32 0C14.356 0 0 14.356 0 32C0 49.644 14.356 64 32 64C49.644 64 64 49.644 64 32C64 14.356 49.644 0 32 0ZM32 4.92308C46.9833 4.92308 59.0769 17.0167 59.0769 32C59.0769 45.6189 49.0711 56.8173 36 58.75V39.8269H43.6442L44.8462 32.0673H36V27.8173C36 24.5927 37.0495 21.7308 40.0673 21.7308H44.9135V14.9519C44.0618 14.8387 42.2625 14.5865 38.8558 14.5865C31.7468 14.5865 27.5769 18.3428 27.5769 26.8942V32.0577H20.2692V39.8269H27.5865V58.6827C14.719 56.5766 4.92308 45.4748 4.92308 32C4.92308 17.0167 17.0167 4.92308 32 4.92308Z" />
        </svg>
      </a>
      <a className="hover:brightness-110" href="https://www.instagram.com/wildfern_grove">
        <svg width="64" height="64" viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg" title="Instagram icon" className="fill-current" style={{width: "30px", height: "30px"}}>
          <path d="M18.5769 0C8.34616 0 0 8.34616 0 18.5769V45.4423C0 55.6538 8.34616 64 18.5769 64H45.4423C55.6538 64 64 55.6539 64 45.4231V18.5769C64 8.34616 55.6539 0 45.4231 0H18.5769ZM18.5769 4.92308H45.4231C53 4.92308 59.0769 11 59.0769 18.5769V45.4231C59.0769 53 53 59.0769 45.4423 59.0769H18.5769C11 59.0769 4.92308 53 4.92308 45.4423V18.5769C4.92308 11 11 4.92308 18.5769 4.92308ZM51.6923 9.84615C50.3269 9.84615 49.2308 10.9423 49.2308 12.3077C49.2308 13.6731 50.3269 14.7692 51.6923 14.7692C53.0577 14.7692 54.1538 13.6731 54.1538 12.3077C54.1538 10.9423 53.0577 9.84615 51.6923 9.84615ZM32 14.7692C22.5192 14.7692 14.7692 22.5192 14.7692 32C14.7692 41.4808 22.5192 49.2308 32 49.2308C41.4808 49.2308 49.2308 41.4808 49.2308 32C49.2308 22.5192 41.4808 14.7692 32 14.7692ZM32 19.6923C38.8269 19.6923 44.3077 25.1731 44.3077 32C44.3077 38.8269 38.8269 44.3077 32 44.3077C25.1731 44.3077 19.6923 38.8269 19.6923 32C19.6923 25.1731 25.1731 19.6923 32 19.6923Z" />
        </svg>
      </a>
    </div>
  );
}

// id: "5e93120c-5cd1-41fe-8e51-d10c87513bbb"
// title: ""
// type: :reference
// key: "footer"
// parent_id: "2d5e8210-e9fe-45a4-8ba2-f8e0ba350b11"
export function Footer5e93120c5cd141fe8e51D10c87513bbb(props: any) {
  return (
    <DefaultFooter5c45b14aC97f4b60Bc2d667d053cffd1 parentTag="Footer5e93120c5cd141fe8e51D10c87513bbb" {...props} />
  );
}

// id: "19e7a28b-f831-4d7d-80a8-928799936f69"
// title: ""
// type: :gf_preset
// key: "about-description"
// parent_id: "265cc7aa-2a5e-4fd6-9aee-e012b321a044"
export function AboutDescription19e7a28bF8314d7d80a8928799936f69(props: any) {
  const ContentSnippet = lookupPreset("ContentSnippet");
  const { parentTag, ...rest } = props;
  props = rest;
  return (
    <ContentSnippet className="AboutDescription19e7a28bF8314d7d80a8928799936f69" parentTag={buildClassName("AboutDescription19e7a28bF8314d7d80a8928799936f69", parentTag)} contentSlug="about-hero-heading" {...props} />
  );
}

// id: "dd799163-5abe-4af8-aba2-422400635259"
// title: ""
// type: :reference
// key: "label"
// parent_id: "387f55e4-f244-4b86-9705-b79fe7dc34b1"
export function LabelDd7991635abe4af8Aba2422400635259(props: any) {
  return (
    <DefaultLogo5cedacf3997d4ed99b9bC409eef78445 parentTag="LabelDd7991635abe4af8Aba2422400635259" {...props} />
  );
}

// id: "303a8114-075c-441e-a862-7daae627861b"
// title: ""
// type: :text
// key: "contentSlug"
// parent_id: "6e290ee9-db0c-433b-88db-2213731a7c3e"
export const ContentSlug303a8114075c441eA8627daae627861b = "about-hero-heading";

// id: "57bddf80-a95c-4b28-84a3-b6f767211b60"
// title: "Message Pages"
// type: :html
// key: "message-pages"
// parent_id: nil
export function MessagePages57bddf80A95c4b2884a3B6f767211b60(props: any) {
  const { parentTag, ...rest } = props;
  props = rest;
  return (
    <div className={`${parentTag || ""} MessagePages57bddf80A95c4b2884a3B6f767211b60 gf-page-layout`}>
      {props["header"] || <MembersAreaHeaderA34abb73E68a42fdBfa0A95e8e70a41c parentTag="Header5e6df4f162c5496cAa57Ed54f7b97854" {...props} />}
      {props.children}
    </div>
  );
}

// id: "387f55e4-f244-4b86-9705-b79fe7dc34b1"
// title: ""
// type: :gf_preset
// key: "linked-logo"
// parent_id: "81f448c9-96c5-4331-a16a-a239380681e1"
export function LinkedLogo387f55e4F2444b869705B79fe7dc34b1(props: any) {
  const Link = lookupPreset("Link");
  const { parentTag, ...rest } = props;
  props = rest;
  return (
    <Link className="LinkedLogo387f55e4F2444b869705B79fe7dc34b1" parentTag={buildClassName("LinkedLogo387f55e4F2444b869705B79fe7dc34b1", parentTag)} label={<DefaultLogo5cedacf3997d4ed99b9bC409eef78445 parentTag="LabelDd7991635abe4af8Aba2422400635259" alt="logo" />} {...props} />
  );
}

// id: "46889201-5f8d-41cc-8434-f311d0961140"
// title: ""
// type: :reference
// key: "header"
// parent_id: "1585a1ba-a6cf-4f2d-a82b-502e90616984"
export function Header468892015f8d41cc8434F311d0961140(props: any) {
  return (
    <SecondaryMarketingHeader23dc1cb3Caa842ddA3f4113c773c503f parentTag="Header468892015f8d41cc8434F311d0961140" title="About Us" {...props} />
  );
}

// id: "acb554c8-9bc9-4fd3-853c-389450e0a4ab"
// title: ""
// type: :reference
// key: "header"
// parent_id: "e0869089-28f4-4f64-b1d2-cb30d11836b4"
export function HeaderAcb554c89bc94fd3853c389450e0a4ab(props: any) {
  return (
    <SecondaryMarketingHeader23dc1cb3Caa842ddA3f4113c773c503f parentTag="HeaderAcb554c89bc94fd3853c389450e0a4ab" title="Resources" {...props} />
  );
}

// id: "a463275c-95cf-4139-9843-f2b6313bfe92"
// title: "About Page Marketing Cards"
// type: :gf_preset
// key: "about-marketing-cards"
// parent_id: "ade53228-def1-4c86-947d-85268fa1b1fa"
export function AboutMarketingCardsA463275c95cf41399843F2b6313bfe92(props: any) {
  const MarketingCards = lookupPreset("MarketingCards");
  const { parentTag, ...rest } = props;
  props = rest;
  return (
    <MarketingCards className="AboutMarketingCardsA463275c95cf41399843F2b6313bfe92" parentTag={buildClassName("AboutMarketingCardsA463275c95cf41399843F2b6313bfe92", parentTag)} postSlug="about-us-posts" imageAs="background" {...props} />
  );
}

// id: "c2b56cf6-0255-4921-8e80-06cafeda22a2"
// title: ""
// type: :text
// key: "title"
// parent_id: "46889201-5f8d-41cc-8434-f311d0961140"
export const TitleC2b56cf6025549218e8006cafeda22a2 = "About Us";

// id: "6bd82c6c-e92e-4596-8eed-52f6adf2a8d7"
// title: ""
// type: :gf_preset
// key: "heading"
// parent_id: "1bf9f241-9c1d-4e06-a1f4-3f84a24d0a4a"
export function Heading6bd82c6cE92e45968eed52f6adf2a8d7(props: any) {
  const ContentSnippet = lookupPreset("ContentSnippet");
  const { parentTag, ...rest } = props;
  props = rest;
  return (
    <ContentSnippet className="Heading6bd82c6cE92e45968eed52f6adf2a8d7" parentTag={buildClassName("Heading6bd82c6cE92e45968eed52f6adf2a8d7", parentTag)} contentSlug="home-hero-heading" {...props} />
  );
}

// id: "fa9263ff-eda1-48e1-ae01-8f3b4d4e2fcd"
// title: "Marketing Cards"
// type: :gf_preset
// key: "marketing-cards"
// parent_id: nil
export function MarketingCardsFa9263ffEda148e1Ae018f3b4d4e2fcd(props: any) {
  const MarketingCards = lookupPreset("MarketingCards");
  const { parentTag, ...rest } = props;
  props = rest;
  return (
    <MarketingCards className="MarketingCardsFa9263ffEda148e1Ae018f3b4d4e2fcd" parentTag={buildClassName("MarketingCardsFa9263ffEda148e1Ae018f3b4d4e2fcd", parentTag)} postSlug="home-page-posts2" buttonClass="inline-block px-12 py-3 hover:brightness-110 transition duration" {...props} />
  );
}

// id: "2945ed59-b438-47ea-a7ad-d8b3931bcbcc"
// title: ""
// type: :reference
// key: "header"
// parent_id: "b87d80fa-6261-4847-9d51-523e572c0e2e"
export function Header2945ed59B43847eaA7adD8b3931bcbcc(props: any) {
  return (
    <SecondaryMarketingHeader23dc1cb3Caa842ddA3f4113c773c503f parentTag="Header2945ed59B43847eaA7adD8b3931bcbcc" {...props} />
  );
}

// id: "3d0132b8-7992-4167-95d7-6f634d4bd396"
// title: ""
// type: :reference
// key: "footer"
// parent_id: "a097cee0-8d8d-413a-a15c-0179f8e61c62"
export function Footer3d0132b87992416795d76f634d4bd396(props: any) {
  return (
    <DefaultFooter5c45b14aC97f4b60Bc2d667d053cffd1 parentTag="Footer3d0132b87992416795d76f634d4bd396" {...props} />
  );
}

// id: "486029ce-929a-432c-8a08-1ced4856caff"
// title: ""
// type: :text
// key: "navMenuSlug"
// parent_id: "b5f9877e-27b3-4a3a-a978-3afc43bf92b0"
export const NavMenuSlug486029ce929a432c8a081ced4856caff = "members-primary-nav";

// id: "619e56f4-0e78-4aef-9e40-dfb2a2736c92"
// title: ""
// type: :text
// key: "title"
// parent_id: "1e3589f2-1700-440f-8f7c-7199bee3eb64"
export const Title619e56f40e784aef9e40Dfb2a2736c92 = "Public Events";

// id: "ccc737dc-5761-4323-b00b-8d713baeb4df"
// title: ""
// type: :text
// key: "postSlug"
// parent_id: "64132897-86bc-43b6-ab78-684f46f78249"
export const PostSlugCcc737dc57614323B00b8d713baeb4df = "home-hero-description";

// id: "29d8d15e-6d52-4d6c-b5da-349023ad6b2b"
// title: "Content Slug"
// type: :text
// key: "contentSlug"
// parent_id: nil
export const ContentSlug29d8d15e6d524d6cB5da349023ad6b2b = "home-hero-heading";

// id: "a11b52de-6dd4-4236-9744-1ed26c1ff7dd"
// title: "Header Area Top"
// type: :html
// key: "default-header-top"
// parent_id: nil
export function DefaultHeaderTopA11b52de6dd4423697441ed26c1ff7dd(props: any) {
  const Link = lookupPreset("Link");
  const PrimaryNavigation = lookupPreset("PrimaryNavigation");
  const { parentTag, ...rest } = props;
  props = rest;
  return (
    <div className={`${parentTag || ""} DefaultHeaderTopA11b52de6dd4423697441ed26c1ff7dd header-top`}>
      {props["linked-logo"] || <Link className="LinkedLogo1667e57779314ccc8df64cc16e673405" parentTag={buildClassName("LinkedLogo1667e57779314ccc8df64cc16e673405", parentTag)} className="linked-logo" url="/" label={<Label784b94679ac34f8489290c966a94a99c />} {...props} />}
      {props["navigation"] || <PrimaryNavigation className="Navigation0628a2c4F93d485fB069A10de15613f8" parentTag={buildClassName("Navigation0628a2c4F93d485fB069A10de15613f8", parentTag)} className="navigation" navMenuSlug="marketing-primary-nav" {...props} />}
    </div>
  );
}

// id: "b5f9877e-27b3-4a3a-a978-3afc43bf92b0"
// title: ""
// type: :gf_preset
// key: "navigation"
// parent_id: "81f448c9-96c5-4331-a16a-a239380681e1"
export function NavigationB5f9877e27b34a3aA9783afc43bf92b0(props: any) {
  const PrimaryNavigation = lookupPreset("PrimaryNavigation");
  const { parentTag, ...rest } = props;
  props = rest;
  return (
    <PrimaryNavigation className="NavigationB5f9877e27b34a3aA9783afc43bf92b0" parentTag={buildClassName("NavigationB5f9877e27b34a3aA9783afc43bf92b0", parentTag)} navMenuSlug="members-primary-nav" {...props} />
  );
}

// id: "81d14398-652d-4340-8ee9-5ce4a8176229"
// title: "site-logo-name"
// type: :html
// key: "site-logo-name"
// parent_id: "5c45b14a-c97f-4b60-bc2d-667d053cffd1"
export function SiteLogoName81d14398652d43408ee95ce4a8176229(props: any) {
  const { parentTag, ...rest } = props;
  props = rest;
  return (
    <img src="https://mp1md-pub.s3-us-west-2.amazonaws.com/content/s2mZXXoqbYzP1qPv_file.svg" alt="wildfern grove logo" className={`${parentTag || ""} SiteLogoName81d14398652d43408ee95ce4a8176229 site-name-logo`} />
  );
}

// id: "ae1b5bfb-5eb9-4b66-8a5b-115ddcac91b6"
// title: ""
// type: :text
// key: "title"
// parent_id: "927e9c74-2e19-4426-9bca-0611737e6a95"
export const TitleAe1b5bfb5eb94b668a5b115ddcac91b6 = "Secondary Page";

// id: "8a8076c4-7a58-4e6e-83b2-7bb9726cda08"
// title: "Members Area"
// type: :html
// key: "members-area-default"
// parent_id: nil
export function MembersAreaDefault8a8076c47a584e6e83b27bb9726cda08(props: any) {
  const { parentTag, ...rest } = props;
  props = rest;
  return (
    <div className={`${parentTag || ""} MembersAreaDefault8a8076c47a584e6e83b27bb9726cda08 page`}>
      {props["header"] || <MembersAreaHeaderA34abb73E68a42fdBfa0A95e8e70a41c parentTag="Header3cd840380ff6498cAde28b401f02dd0a" navMenuSlug="members-primary-nav" {...props} />}
      {props["footer"] || <DefaultFooter5c45b14aC97f4b60Bc2d667d053cffd1 parentTag="Footer11bf62b76597495594fdC1c057d37985" {...props} />}
    </div>
  );
}

// id: "206d6d00-27e0-455b-a543-ff69f2d9b5e2"
// title: ""
// type: :gf_preset
// key: "heading"
// parent_id: "05dcb6de-83a6-4ebf-bdcc-3e9afa0ef4a7"
export function Heading206d6d0027e0455bA543Ff69f2d9b5e2(props: any) {
  const ContentSnippet = lookupPreset("ContentSnippet");
  const { parentTag, ...rest } = props;
  props = rest;
  return (
    <ContentSnippet className="Heading206d6d0027e0455bA543Ff69f2d9b5e2" parentTag={buildClassName("Heading206d6d0027e0455bA543Ff69f2d9b5e2", parentTag)} contentSlug="home-hero-heading" {...props} />
  );
}

// id: "e9268404-396b-48e6-8cc9-7312afe77d2a"
// title: ""
// type: :reference
// key: "header"
// parent_id: "b87d80fa-6261-4847-9d51-523e572c0e2e"
export function HeaderE9268404396b48e68cc97312afe77d2a(props: any) {
  return (
    <SecondaryMarketingHeader23dc1cb3Caa842ddA3f4113c773c503f parentTag="HeaderE9268404396b48e68cc97312afe77d2a" title="Join Us" {...props} />
  );
}

// id: "556a7f7a-7231-4b7d-bda6-85fc9337f952"
// title: ""
// type: :gf_preset
// key: "welcome-back"
// parent_id: "6a5727f2-037d-4506-9d66-0cb7ee7e4d89"
export function WelcomeBack556a7f7a72314b7dBda685fc9337f952(props: any) {
  const WelcomeBackPopUp = lookupPreset("WelcomeBackPopUp");
  const { parentTag, ...rest } = props;
  props = rest;
  return (
    <WelcomeBackPopUp className="WelcomeBack556a7f7a72314b7dBda685fc9337f952" parentTag={buildClassName("WelcomeBack556a7f7a72314b7dBda685fc9337f952", parentTag)} {...props} />
  );
}

// id: "1dbe09e0-9fca-4bcd-bf9d-a57cfbae2cec"
// title: ""
// type: :text
// key: "navMenuSlug"
// parent_id: "0628a2c4-f93d-485f-b069-a10de15613f8"
export const NavMenuSlug1dbe09e09fca4bcdBf9dA57cfbae2cec = "marketing-primary-nav";

// id: "9b10f5cd-3092-4323-b32a-da955ce1326b"
// title: ""
// type: :text
// key: "contentSlug"
// parent_id: "64132897-86bc-43b6-ab78-684f46f78249"
export const ContentSlug9b10f5cd30924323B32aDa955ce1326b = "home-hero-description";

// id: "a097cee0-8d8d-413a-a15c-0179f8e61c62"
// title: "Member Pages"
// type: :html
// key: "member-pages"
// parent_id: nil
export function MemberPagesA097cee08d8d413aA15c0179f8e61c62(props: any) {
  const { parentTag, ...rest } = props;
  props = rest;
  return (
    <div className={`${parentTag || ""} MemberPagesA097cee08d8d413aA15c0179f8e61c62 gf-page-layout`}>
      {props["header"] || <MembersAreaHeaderA34abb73E68a42fdBfa0A95e8e70a41c parentTag="HeaderA4d4251a90c249ebB93522dea79dfe9a" {...props} />}
      <main className="MainContent">
        {props.children}
      </main>
      {props["footer"] || <DefaultFooter5c45b14aC97f4b60Bc2d667d053cffd1 parentTag="Footer3d0132b87992416795d76f634d4bd396" {...props} />}
    </div>
  );
}

// id: "50569397-5139-4ef7-950a-c48ecb0a6738"
// title: ""
// type: :gf_preset
// key: "button"
// parent_id: "05dcb6de-83a6-4ebf-bdcc-3e9afa0ef4a7"
export function Button5056939751394ef7950aC48ecb0a6738(props: any) {
  const Button = lookupPreset("Button");
  const { parentTag, ...rest } = props;
  props = rest;
  return (
    <Button className="Button5056939751394ef7950aC48ecb0a6738" parentTag={buildClassName("Button5056939751394ef7950aC48ecb0a6738", parentTag)} href="/join" label="Join Us" {...props} />
  );
}

// id: "71ac7d6e-c00c-4b56-98fb-25e7d648a9f1"
// title: ""
// type: :text
// key: "backgroundImage"
// parent_id: "81f448c9-96c5-4331-a16a-a239380681e1"
export const BackgroundImage71ac7d6eC00c4b5698fb25e7d648a9f1 = "https://mp1md-pub.s3.amazonaws.com/orgs/sample/city-background.jpg";

// id: "1f8874f4-d59f-4f68-ac45-7d1e02402830"
// title: ""
// type: :reference
// key: "header"
// parent_id: "7b267b6c-e53d-41b6-8abc-d5338e53f58f"
export function Header1f8874f4D59f4f68Ac457d1e02402830(props: any) {
  return (
    <SecondaryMarketingHeader23dc1cb3Caa842ddA3f4113c773c503f parentTag="Header1f8874f4D59f4f68Ac457d1e02402830" title="Join Us" {...props} />
  );
}

// id: "4b0ff4e1-e3bd-4062-900c-fdc209e87ef4"
// title: ""
// type: :text
// key: "label"
// parent_id: "50569397-5139-4ef7-950a-c48ecb0a6738"
export const Label4b0ff4e1E3bd4062900cFdc209e87ef4 = "Join Us";

// id: "9042bbe6-f908-4e01-9e4a-52e20327a6f6"
// title: ""
// type: :text
// key: "class"
// parent_id: "1667e577-7931-4ccc-8df6-4cc16e673405"
export const Class9042bbe6F9084e019e4a52e20327a6f6 = "linked-logo";

// id: "6c46d3c0-a703-4b0d-8d4d-94f4773321cf"
// title: ""
// type: :text
// key: "className"
// parent_id: "64132897-86bc-43b6-ab78-684f46f78249"
export const ClassName6c46d3c0A7034b0d8d4d94f4773321cf = "home-hero-description";

// id: "05dcb6de-83a6-4ebf-bdcc-3e9afa0ef4a7"
// title: "Home Page Hero"
// type: :html
// key: "home-page-hero"
// parent_id: nil
export function HomePageHero05dcb6de83a64ebfBdcc3e9afa0ef4a7(props: any) {
  const ContentSnippet = lookupPreset("ContentSnippet");
  const { parentTag, ...rest } = props;
  props = rest;
  return (
    <section className={`${parentTag || ""} HomePageHero05dcb6de83a64ebfBdcc3e9afa0ef4a7 `}>
      <div className="hero-content">
        {props["heading"] || <ContentSnippet className="Heading206d6d0027e0455bA543Ff69f2d9b5e2" parentTag={buildClassName("Heading206d6d0027e0455bA543Ff69f2d9b5e2", parentTag)} contentSlug="home-hero-heading" {...props} />}
        <div className="hero-button-container">
          <a href="#welcome-main-section">
            <button className="hero-button">
              <span className="svg-container-hero">
                <svg className="button-svg" data-bbox="19.999 58 160.001 84" viewBox="0 0 200 200" height="28" width="28" xmlns="http://www.w3.org/2000/svg" data-type="shape">
                  <g transform="rotate(180 100 100)">
                    <path d="M172.5 142a7.485 7.485 0 0 1-5.185-2.073L100 75.808l-67.315 64.12c-2.998 2.846-7.74 2.744-10.606-.234a7.454 7.454 0 0 1 .235-10.565l72.5-69.057a7.524 7.524 0 0 1 10.371 0l72.5 69.057a7.455 7.455 0 0 1 .235 10.565A7.503 7.503 0 0 1 172.5 142z" fill="white" />
                  </g>
                </svg>
              </span>
            </button>
          </a>
        </div>
      </div>
    </section>
  );
}

// id: "ce7fc6a8-f9d4-4167-9925-d33fae389f10"
// title: ""
// type: :text
// key: "title"
// parent_id: "4b20c25c-aabd-4789-93cc-53e81a401f4f"
export const TitleCe7fc6a8F9d441679925D33fae389f10 = null;

// id: "11bf62b7-6597-4955-94fd-c1c057d37985"
// title: ""
// type: :reference
// key: "footer"
// parent_id: "8a8076c4-7a58-4e6e-83b2-7bb9726cda08"
export function Footer11bf62b76597495594fdC1c057d37985(props: any) {
  return (
    <DefaultFooter5c45b14aC97f4b60Bc2d667d053cffd1 parentTag="Footer11bf62b76597495594fdC1c057d37985" {...props} />
  );
}

// id: "010ee782-16be-4729-8d7b-4159c591659e"
// title: ""
// type: :text
// key: "title"
// parent_id: "700b99fa-20d5-4222-9c30-4824a608b81a"
export const Title010ee78216be47298d7b4159c591659e = "Leveling";

// id: "9c47b1a1-5c48-4d20-94a1-554ee7c3d904"
// title: ""
// type: :text
// key: "buttonClass"
// parent_id: "fa9263ff-eda1-48e1-ae01-8f3b4d4e2fcd"
export const ButtonClass9c47b1a15c484d2094a1554ee7c3d904 = "inline-block px-12 py-3 hover:brightness-110 transition duration";

// id: "60f36268-1c74-4f05-8685-3ec654761c5c"
// title: ""
// type: :reference
// key: "header-top"
// parent_id: "23dc1cb3-caa8-42dd-a3f4-113c773c503f"
export function HeaderTop60f362681c744f0586853ec654761c5c(props: any) {
  return (
    <DefaultHeaderTopA11b52de6dd4423697441ed26c1ff7dd parentTag="HeaderTop60f362681c744f0586853ec654761c5c" {...props} />
  );
}

// id: "89ffa685-96e6-47cd-8c43-b1e02ad02d9e"
// title: ""
// type: :reference
// key: "header-top"
// parent_id: "a34abb73-e68a-42fd-bfa0-a95e8e70a41c"
export function HeaderTop89ffa68596e647cd8c43B1e02ad02d9e(props: any) {
  return (
    <DefaultHeaderTopA11b52de6dd4423697441ed26c1ff7dd parentTag="HeaderTop89ffa68596e647cd8c43B1e02ad02d9e" navMenuSlug="members-primary-nav" {...props} />
  );
}

// id: "af3b0a6c-dc12-420f-a652-3903862eafc3"
// title: ""
// type: :text
// key: "url"
// parent_id: "1667e577-7931-4ccc-8df6-4cc16e673405"
export const UrlAf3b0a6cDc12420fA6523903862eafc3 = "/";

// id: "784b9467-9ac3-4f84-8929-0c966a94a99c"
// title: ""
// type: :html
// key: "label"
// parent_id: "1667e577-7931-4ccc-8df6-4cc16e673405"
export function Label784b94679ac34f8489290c966a94a99c(props: any) {
  const { parentTag, ...rest } = props;
  props = rest;
  return (
    <img src="https://mp1md-pub.s3-us-west-2.amazonaws.com/content/omEtAozQA9rCypTr_file.svg" className={`${parentTag || ""} Label784b94679ac34f8489290c966a94a99c logo`} />
  );
}

// id: "cf7efbeb-479b-489b-ac51-b972e40de4c3"
// title: ""
// type: :text
// key: "postSlug"
// parent_id: "8c49e557-5ac1-4b07-9fa9-dc89f842fa6e"
export const PostSlugCf7efbeb479b489bAc51B972e40de4c3 = "home-hero";

// id: "ade53228-def1-4c86-947d-85268fa1b1fa"
// title: ""
// type: :html
// key: "body"
// parent_id: "1585a1ba-a6cf-4f2d-a82b-502e90616984"
export function BodyAde53228Def14c86947d85268fa1b1fa(props: any) {
  const MarketingCards = lookupPreset("MarketingCards");
  const { parentTag, ...rest } = props;
  props = rest;
  return (
    <main className={`${parentTag || ""} BodyAde53228Def14c86947d85268fa1b1fa`}>
      {props["about-marketing-cards"] || <MarketingCards className="AboutMarketingCardsA463275c95cf41399843F2b6313bfe92" parentTag={buildClassName("AboutMarketingCardsA463275c95cf41399843F2b6313bfe92", parentTag)} postSlug="about-us-posts" imageAs="background" {...props} />}
    </main>
  );
}

// id: "50c34b9c-9c49-41de-a43c-9fefb0540753"
// title: ""
// type: :text
// key: "title"
// parent_id: "2151a24d-eefd-489c-bece-0d7a48801652"
export const Title50c34b9c9c4941deA43c9fefb0540753 = "Secondary Marketing Title 2";

// id: "814a228e-7b75-4737-ba2c-6d87fbe3465c"
// title: ""
// type: :text
// key: "contentSlug"
// parent_id: "206d6d00-27e0-455b-a543-ff69f2d9b5e2"
export const ContentSlug814a228e7b754737Ba2c6d87fbe3465c = "home-hero-heading";

// id: "d1d72bc8-ad2e-435c-8ddd-4c6ed87a4707"
// title: ""
// type: :text
// key: "imageAs"
// parent_id: "a463275c-95cf-4139-9843-f2b6313bfe92"
export const ImageAsD1d72bc8Ad2e435c8ddd4c6ed87a4707 = "background";

// id: "6e290ee9-db0c-433b-88db-2213731a7c3e"
// title: "about hero heading"
// type: :gf_preset
// key: "about-hero-heading"
// parent_id: "ada69417-e71f-4fd5-8a57-f6171c168f33"
export function AboutHeroHeading6e290ee9Db0c433b88db2213731a7c3e(props: any) {
  const ContentSnippet = lookupPreset("ContentSnippet");
  const { parentTag, ...rest } = props;
  props = rest;
  return (
    <ContentSnippet className="AboutHeroHeading6e290ee9Db0c433b88db2213731a7c3e" parentTag={buildClassName("AboutHeroHeading6e290ee9Db0c433b88db2213731a7c3e", parentTag)} contentSlug="about-hero-heading" {...props} />
  );
}

// id: "95f7114a-068f-4f61-b0ec-f3704f568faa"
// title: ""
// type: :text
// key: "contentSlug"
// parent_id: "19e7a28b-f831-4d7d-80a8-928799936f69"
export const ContentSlug95f7114a068f4f61B0ecF3704f568faa = "about-hero-heading";

// id: "6d174b59-f9d0-4f29-9600-2096acd6c133"
// title: ""
// type: :text
// key: "navMenuSlug"
// parent_id: "89ffa685-96e6-47cd-8c43-b1e02ad02d9e"
export const NavMenuSlug6d174b59F9d04f2996002096acd6c133 = "members-primary-nav";

// id: "811fd0eb-924f-447e-9017-b2d821ab70cf"
// title: ""
// type: :text
// key: "contentSlug"
// parent_id: "6bd82c6c-e92e-4596-8eed-52f6adf2a8d7"
export const ContentSlug811fd0eb924f447e9017B2d821ab70cf = "home-hero-heading";

const Components = {
  TitleB31ef92686fb4762Bd01017d505dd5fb,
  SignupPages7b267b6cE53d41b68abcD5338e53f58f,
  Header3cd840380ff6498cAde28b401f02dd0a,
  FooterC486c5383b2c42e98f6565284fe94714,
  TitleF54e85d4E5c34632A185Ce4c2b0cc716,
  PostSlug71e1eac2108140a6Ab7c35703ea66141,
  ClassE119feb91d1e4529A70fF675a57b68ce,
  JoinUsPageB87d80fa626148479d51523e572c0e2e,
  PageQuoteB3f31a5e17c94398Bcfd60fd5026509a,
  Logo0e616d6436b94ac1994605e9d0ea3ac1,
  HeaderA4d4251a90c249ebB93522dea79dfe9a,
  HrefAf7731abA33148319f473df83d1397ce,
  NavMenuSlugC0d712c6Fc874f2b84a88447e4469d9c,
  Href63b455f723cf48b0Ad6a8cdb168303c5,
  PublicEventsPage2d5e8210E9fe45a48ba2F8e0ba350b11,
  AboutHero1265cc7aa2a5e4fd69aeeE012b321a044,
  Header5e6df4f162c5496cAa57Ed54f7b97854,
  LinkedLogo1667e57779314ccc8df64cc16e673405,
  NavMenuSlug204e46fd20ff49a9A31159eda5464b96,
  ShortHeader81f448c996c54331A16aA239380681e1,
  MembersAreaHeaderA34abb73E68a42fdBfa0A95e8e70a41c,
  Footer3610d6566863450e8b63F38e276a30fe,
  Header1e3589f21700440f8f7c7199bee3eb64,
  Title0a7f8aa29720454fAc05222beb52786d,
  Hero1bf9f2419c1d4e06A1f43f84a24d0a4a,
  MarketingBodyA57b808d01b54347Bb19E00ef81335dd,
  SecondaryMarketingHeroDc681546D42e496aA5faC04061177fef,
  ImageUrlE392db0a62bc42478f751344f1cddcd3,
  Groupflow34bba55f70be4a4b914781316cb16ad9,
  AboutDescriptionAda69417E71f4fd58a57F6171c168f33,
  Description6413289786bc43b6Ab78684f46f78249,
  Header09bc8405E1ee4e89A9e252d06d270cf3,
  AboutLevelingPageB6e762fb9ca8496aA09c9e076575c19c,
  Navigation0628a2c4F93d485fB069A10de15613f8,
  HeaderEf224d127ceb4027B55c15c4d59c533c,
  Footer64e72cdbA88b434e88ef349331431676,
  Title22906bf372474592A078Dbf8e23f433d,
  AboutUsPage1585a1baA6cf4f2dA82b502e90616984,
  PostSlug693fe5f42273440f922930aaebf2e859,
  Header927e9c742e1944269bca0611737e6a95,
  Links12586cb11b854103B901D614f9cb41af,
  HeroContent8c49e5575ac14b079fa9Dc89f842fa6e,
  DefaultLogo5cedacf3997d4ed99b9bC409eef78445,
  ResourcesPageE086908928f44f64B1d2Cb30d11836b4,
  Alt7bad446bEa504372843bB3f1190b2dfa,
  ContactEb0b0733712e4fe6Af0c78eee50ddb72,
  Copyright32428d79F98040db98791d1bacbbe1d0,
  TitleE08a179349284e05B3fe075abca1f20a,
  PostSlugE6cf557a50434948B51888cdb95eb3d1,
  AdminPagesEa5f882529224a5290ea04d1d2976c00,
  DefaultFooter5c45b14aC97f4b60Bc2d667d053cffd1,
  ServicesPostsC47a5a03E5e9474eB21d4720ecdc3880,
  Title5d8a2f7f269c45328503Caba777bdfa1,
  PostSlug5dfd6dcc1ff54dae9e3e810abea3ff7f,
  Label1606a2e1B61e4b5b9fa8601f1fa71383,
  ContentSlug697a975f028b4f178d436e00809c698c,
  Header700b99fa20d542229c304824a608b81a,
  Footer8e9f964b0f894bc2B756788cb9660a44,
  Hero2151a24dEefd489cBece0d7a48801652,
  HeaderTop0fd3ec7925904205A29eF16d7bf3ae9c,
  SecondaryMarketingHeader23dc1cb3Caa842ddA3f4113c773c503f,
  DefaultHeader4b20c25cAabd478993cc53e81a401f4f,
  MarketingCards0983ef896614400bBd1b2b06eb06ffee,
  FooterA35e60aaC0ac4dba9c0599fcf9bdf738,
  Footer4e7960799cb0460bB1b556e1b68c650c,
  HomePage6a5727f2037d45069d660cb7ee7e4d89,
  Body1525c7c1E826448c8d60F15200a9ba2e,
  SecondaryPage5e00d16d1e464b4e99db0fc71584315b,
  NavMenuSlug2858f0faB0db4a27811a950b42fac49b,
  SocialBa322a750852466299123c745556a2e7,
  Footer5e93120c5cd141fe8e51D10c87513bbb,
  AboutDescription19e7a28bF8314d7d80a8928799936f69,
  LabelDd7991635abe4af8Aba2422400635259,
  ContentSlug303a8114075c441eA8627daae627861b,
  MessagePages57bddf80A95c4b2884a3B6f767211b60,
  LinkedLogo387f55e4F2444b869705B79fe7dc34b1,
  Header468892015f8d41cc8434F311d0961140,
  HeaderAcb554c89bc94fd3853c389450e0a4ab,
  AboutMarketingCardsA463275c95cf41399843F2b6313bfe92,
  TitleC2b56cf6025549218e8006cafeda22a2,
  Heading6bd82c6cE92e45968eed52f6adf2a8d7,
  MarketingCardsFa9263ffEda148e1Ae018f3b4d4e2fcd,
  Header2945ed59B43847eaA7adD8b3931bcbcc,
  Footer3d0132b87992416795d76f634d4bd396,
  NavMenuSlug486029ce929a432c8a081ced4856caff,
  Title619e56f40e784aef9e40Dfb2a2736c92,
  PostSlugCcc737dc57614323B00b8d713baeb4df,
  ContentSlug29d8d15e6d524d6cB5da349023ad6b2b,
  DefaultHeaderTopA11b52de6dd4423697441ed26c1ff7dd,
  NavigationB5f9877e27b34a3aA9783afc43bf92b0,
  SiteLogoName81d14398652d43408ee95ce4a8176229,
  TitleAe1b5bfb5eb94b668a5b115ddcac91b6,
  MembersAreaDefault8a8076c47a584e6e83b27bb9726cda08,
  Heading206d6d0027e0455bA543Ff69f2d9b5e2,
  HeaderE9268404396b48e68cc97312afe77d2a,
  WelcomeBack556a7f7a72314b7dBda685fc9337f952,
  NavMenuSlug1dbe09e09fca4bcdBf9dA57cfbae2cec,
  ContentSlug9b10f5cd30924323B32aDa955ce1326b,
  MemberPagesA097cee08d8d413aA15c0179f8e61c62,
  Button5056939751394ef7950aC48ecb0a6738,
  BackgroundImage71ac7d6eC00c4b5698fb25e7d648a9f1,
  Header1f8874f4D59f4f68Ac457d1e02402830,
  Label4b0ff4e1E3bd4062900cFdc209e87ef4,
  Class9042bbe6F9084e019e4a52e20327a6f6,
  ClassName6c46d3c0A7034b0d8d4d94f4773321cf,
  HomePageHero05dcb6de83a64ebfBdcc3e9afa0ef4a7,
  TitleCe7fc6a8F9d441679925D33fae389f10,
  Footer11bf62b76597495594fdC1c057d37985,
  Title010ee78216be47298d7b4159c591659e,
  ButtonClass9c47b1a15c484d2094a1554ee7c3d904,
  HeaderTop60f362681c744f0586853ec654761c5c,
  HeaderTop89ffa68596e647cd8c43B1e02ad02d9e,
  UrlAf3b0a6cDc12420fA6523903862eafc3,
  Label784b94679ac34f8489290c966a94a99c,
  PostSlugCf7efbeb479b489bAc51B972e40de4c3,
  BodyAde53228Def14c86947d85268fa1b1fa,
  Title50c34b9c9c4941deA43c9fefb0540753,
  ContentSlug814a228e7b754737Ba2c6d87fbe3465c,
  ImageAsD1d72bc8Ad2e435c8ddd4c6ed87a4707,
  AboutHeroHeading6e290ee9Db0c433b88db2213731a7c3e,
  ContentSlug95f7114a068f4f61B0ecF3704f568faa,
  NavMenuSlug6d174b59F9d04f2996002096acd6c133,
  ContentSlug811fd0eb924f447e9017B2d821ab70cf
}

export default Components;